export const wasteTypeField = 'wasteTypeId';
export const wasteTypeError = 'This waste type already exists';
export const treatmentMethodField = 'treatmentMethod';
export const treatmentMethodError = 'This treatment method already exist';
